import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const AcessorioCelular = () => {

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Trinco | Celulares";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.acessorioCelular})` }}>
        <div className="servico-hero-overlay">
          <h1>Celular</h1>
          {/*  <p>Acessórios para celular, capas, cabos, suportes, etc.</p> */}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos */}
        <section className="acessorios-grid">

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.carregadorCelular} alt="" /></div>
            <h3>Energia</h3>
            <p>Carregadores, fontes e modelos por indução.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.foneOuvido} alt="" /></div>
            <h3>Áudio</h3>
            <p>Fones com fio e bluetooth.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.cabosUSB} alt="" /></div>
            <h3>Conexão</h3>
            <p>Cabos USB para recarga e transferência de dados.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.suporteCelular} alt="" /></div>
            <h3>Suporte</h3>
            <p>Suportes para mesa, carro e selfie.</p>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('celular')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('celulares', document.title)}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default AcessorioCelular;